module.exports = __webpack_public_path__ + "static/stb_separator-structure@2x-b2ca126cfd37dfafd32caa8731d967fb.jpg";